import AdEvents from './ad-events';
import ControlEvents from './control-events';
import ItemEvents from './item-events';
import GlobalEvents from './global-events';
import PlayerEvents from './player-events';
import PlaylistEvents from './playlist-events';
import UiEvents from './ui-events';

const EventDefaults = [];

EventDefaults.push(...AdEvents);
EventDefaults.push(...ControlEvents);
EventDefaults.push(...ItemEvents);
EventDefaults.push(...GlobalEvents);
EventDefaults.push(...PlayerEvents);
EventDefaults.push(...PlaylistEvents);
EventDefaults.push(...UiEvents);

export default EventDefaults;



// WEBPACK FOOTER //
// ./src/js/events/default-events.js